<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>

    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">

        <span class="font-weight-light">{{$store.state.device ? ($store.state.device.device_name || $store.state.device.device_token) : "Loading..."}}</span>
        <span
          class="font-weight-medium"
          v-if="$store.state.device && ($store.state.device.address || $store.state.device.city)"
        > | {{$store.state.device.address}}, {{$store.state.device.city}}, {{$store.state.device.state}}, {{$store.state.device.postcode}} </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <m-menubutton
        icon="mdi-chart-timeline-variant"
        @click="$router.push('/log/' + $route.params.id)"
      >Chart</m-menubutton>
      <v-spacer></v-spacer>
    </navbar>

    <v-content class="secondary--text text--darken-2">
      <v-container fluid fill-height>
        <v-row justify="start" fill-height>
          <v-col xs="12" sm="6" md="4" lg="3">
            <v-card>
              <v-card-title class="primary text-center pa-4 secondary--text text--darken-3">
                <v-row justify="center">
                  <span class="text-uppercase text-center font-weight-light">
                    <span class="font-weight-medium">Device Details</span>
                  </span>
                </v-row>
              </v-card-title>
              <v-card-text>
                <m-form
                  v-slot="{model}"
                  :query="apiEndpoints.updateDevice"
                  :params="[deviceData.id]"
                  :rules="validationRules"
                  :modelSrc="deviceData"
                  @success="onUpdateSuccess"
                  @cancel="onFormCancel"
                  class="ma-2"
                  lazy-validation
                >
                  <v-row align="center" justify="center">
                    <v-col class="pa-0">
                      <m-textinput :model="model" name="device_name" label="Site Name"></m-textinput>
                    </v-col>
                  </v-row>

                  <v-row align="center" justify="center">
                    <v-col class="pa-0">
                      <h-autocomplete
                        :model="model"
                        name="address_search"
                        label="Address Search"
                        @update:address_search="setCoords"
                        :updateAddressFields="true"
                      ></h-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center" v-if="updatedActiveLocation">
                    <v-col class="pa-0">
                      <m-checkbox
                        dense
                        :model="model"
                        name="update_coords"
                        label="Move map marker to new address"
                      ></m-checkbox>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col class="pa-0">
                      <m-textinput :model="model" name="address" label="Address"></m-textinput>
                    </v-col>
                  </v-row>

                  <v-row align="center" justify="center">
                    <v-col class="pa-0">
                      <m-textinput :model="model" name="city" label="City"></m-textinput>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col cols="12" sm="7" class="pa-0">
                      <m-textinput :model="model" name="state" label="State"></m-textinput>
                    </v-col>
                    <v-col class="pa-0">
                      <m-textinput :model="model" name="postcode" label="Post Code"></m-textinput>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col class="pa-0">
                      <m-textarea :model="model" name="comments" label="Comments"></m-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-0">
                      <m-submit label="Update" :model="model"></m-submit>
                      <v-btn text color="primary" class="mb-3" @click="model.onFormCancel()">Cancel</v-btn>
                    </v-col>
                  </v-row>
                </m-form>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card style="height:calc(100vh - 140px);" fill-height>
              <olMap
                left="0"
                top="55px"
                interactionType="Select"
                :showNewNote="false"
                :showNotes="true"
                :activeLocation="activeMarkerLocation"
                :otherLocations="($store.state.device && $store.state.device.nearby) || []"
                @singleFeatureSelected="onMapSelect"
                @multiFeatureSelected="onMapDeselect"
                @noFeatureSelected="onMapDeselect"
                @saveActiveLocation="onSaveActiveDeviceCoords"
              ></olMap>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
//import chtFileLoader from '../mixins/chtloader';
import usbReq from "../mixins/usb-request"; // only for the loadChartResponse Function.
import apiEp from "../mixins/api-endpoints";
import apiReq from "../mixins/api-request";
import formatDate from "../mixins/format-date";

export default {
  mixins: [usbReq, apiEp, apiReq, formatDate],
  data() {
    return {
      valid: true,
      showPassword: false,
      validationRules: {
        device_name: model => [
          //v => !!v || "Site Name is required",
          v => !v || (v.length <= 64 && v.length >= 3) || "Site Name must be between 3 and 64 characters.",
        ],
      },
      updatedActiveLocation: null,
    };
  },
  computed: {
    deviceData() {

      if (! this.$store.state.device) return {};

      return {
        //...this.$store.state.log,
        device_name:this.$store.state.device.device_name,
        device_token:this.$store.state.device.device_token,
        address:this.$store.state.device.address,
        city:this.$store.state.device.city,
        comments:this.$store.state.device.comments,
        id:this.$store.state.device.id,
        latitude:this.$store.state.device.latitude,
        longitude:this.$store.state.device.longitude,
        postcode:this.$store.state.device.postcode,
        state:this.$store.state.device.state,

        update_coords: true,
      };
    },
    activeMarkerLocation(){
      return this.updatedActiveLocation || (this.$store.state.device && {latitude:this.$store.state.device.latitude, longitude:this.$store.state.device.longitude}) || null;

    }

  },
  methods: {
    showError(err) {
      this.$refs.errorBox.showError(err);
    },
    onUpdateSuccess(body) {
      console.log("Update Success.");
      // always assign device attributes to a fresh object to trigger reactivity

      this.$store.commit(
        "setDevice",
        Object.assign({}, this.$store.state.device, body.data)
      );
      Vue.set(this, "updatedActiveLocation", null);
      console.log(body.data);
    },
    onFormCancel(body) {
      Vue.set(this, "updatedActiveLocation", null);
    },
    onMapSelect(evt) {},
    onMapDeselect(evt) {},
    onSaveActiveDeviceCoords(evt) {
      console.log(evt);

      this.apiRequest(
        this.apiEndpoints.updateDevice,
        [this.$store.state.device.id],
        evt
      )
        .then(r => {
          if (!this.statusOk(r.status)) {
            console.log(r);
            this.showError("Error saving device coordinates.");
          } else {
            console.log("Device details saved to server.");

            // turn the unix timestamps into JS date objects.
            r.body.data.started_at = new Date(r.body.data.started_at * 1000);
            r.body.data.ended_at = new Date(r.body.data.ended_at * 1000);

            // we need to replace the top level device object, or the reactivity system sees it as the
            // same object, so assign all properties to an empty object before commiting.
            this.$store.commit(
              "setDevice",
              Object.assign({}, this.$store.state.device, r.body.data)
            );
          }
        })
        .catch(err => {
          console.log(err);
          this.showError("Error saving device coordinates.");
        });
    },
    setCoords(evt) {
      console.log("Event emitted!");
      console.log(evt);
      Vue.set(this, "updatedActiveLocation", evt);
    },
    initView(id) {
      // load a new device if we don't already have the right one loaded.
      if ((this.$store.state.device || {}).id != id) {
        console.log("Loading device ID: " + id);
        this.apiRequest(this.apiEndpoints.devices, id).then(r => {
          if (this.checkStatus(r, "Error getting file from server.")) {
            // note that this action will leave 'log.readings' undefined intentionally.
            this.$store.commit('setDevice', r.body.data);
            this.$store.commit('incrementLogVersion');

          }
        });
      }
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.params.id);
      this.initView(to.params.id);
    }
  },
  mounted() {
    this.updatedActiveLocation
    this.initView(this.$route.params.id);
  }
};
</script>
